/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/4
 * @updateTime 2021/11/4
 * @decription 选择路由组件入口js
 */
// 表单的布局组件
import acLayoutForm from '@/components/app/layout/form/index.vue';
export default {
    name: 'ac-select-ay',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        acLayoutForm
    },
    // 参数
    props: {
        // 案件类型
        ajlx: {
            type: String|Number
        },
        // 年份
        nf: {
            type: Number|String
        },
        // 案由文本
        name: {
            type: String
        },
        // 案由代码
        code: {
            type: String
        }
    },
    // 数据
    data() {
        return {
            // 当前作用域变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-ac-select-ay'
            },
            info: {
                checkedFy: this.name,
                checkedFyId: this.code,
                selectAyId: '',
                cId: ""
            },
            // 活跃的tab项
            active: 0,
            ayListAll: {},
            // 案由数据
            ayData: {
                // 一级案由列表
                yj: [],
                // 二级案由列表
                ej: [],
                // 三级案由列表
                saj: [],
                // 四级案由列表
                sij: []
            }
        };
    },
    // 计算属性
    computed: {
        /**
         * 容器类名
         * @returns {Array<String>} 类名数组
         * */
        wrapClasses() {
            return [
                this.scope.prefixCls
            ];
        }
    },
    // 创建完成
    created() {
        // 创建完成
        this.init();
    },
    // 方法
    methods: {

        /**
         * 初始化方法
         * */
        init() {
            // 请求案由列表数据
            this.getAyData();
        },

        /**
         * 组装数据
         * @param {Object} data 案由数据
         * @returns {void}
         * */
        assembleData(data) {
            // 活跃的页签
            this.active=0;
            // 案由年份
            const key=(parseInt(this.nf || 2020) >= 2021)? 2021 : 2020;
            // 赋值一级案由数据
            this.ayData.yj = data[key][this.ajlx==6 ? 61: this.ajlx][0].children;
            // 二级
            this.ayData.ej = [];
            // 三级
            this.ayData.saj = [];
            // 四级
            this.ayData.sij = []
        },

        /**
         * 请求案由数据
         * @returns {void}
         * */
        getAyData() {
            let ayListAll = sessionStorage.getItem('ayListAll');
            console.log('--ayListAll 000',ayListAll);
            if(ayListAll){
                this.assembleData(JSON.parse(ayListAll));
            }
            this.$axios.get('ssbq/api/bqsqs/new/ay').then(res => {
                console.log('--res 000', res);
                // 案由列表进行存储
                sessionStorage.setItem('ayListAll', JSON.stringify(res.data));
                this.assembleData(res.data);
            })
        },

        /**
         * 点击了案由信息项
         * @param {Object} item 案由信息项
         * @param {Number} level 案由级别 1 一级 2 二级 3 三级 4 四级
         * @returns {void}
         * */
        eClickAy(item, level) {
            this.info.checkedFy = item.name;
            this.info.checkedFyId = item.id;
            // 如果是三级以下，则不往下执行了
            if (level > 3) {
                return;
            }
            // 子集数据列表
            const _dataList = item.children;
            switch (level) {
                case 1:
                    this.ayData.ej = _dataList;
                    this.ayData.saj = [];
                    this.ayData.sij = [];
                    break;
                case 2:
                    this.ayData.saj = _dataList;
                    this.ayData.sij = [];
                    break;
                case 3:
                    this.ayData.sij = _dataList;
                    break;
            }
        },

        // 返回
        back() {
            this.$emit('cancel');
        },

        //点击确定按钮
        eClickSure() {
            // 向上分发确定事件
            this.$emit('confirm', this.info.checkedFyId, this.info.checkedFy);
        }
    }
};
